import { Button } from 'antd';
import styled, { css } from 'styled-components';

// Common Style for date-range and single-date-range,

export const DatePickerWrapper = styled.div<{ contentHeight?: number }>`
  height: 100%;

  @media (min-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    .DayPicker_transitionContainer {
      height: 300px !important;
    }
  }

  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (stroke-color: transparent) {
      height: ${({ contentHeight }) => contentHeight + 'px'};
    }
  }

  .CalendarDay__selected_span {
    background-color: rgb(245 191 101 / 20%);
    color: ${({ theme }) => theme.palette.black};
  }
  .CalendarDay__hovered_span {
    background-color: rgb(245 191 101 / 20%);
    color: ${({ theme }) => theme.palette.black};
  }
  .CalendarDay__default {
    border: none;

    :not(.CalendarDay__blocked_out_of_range) :hover {
      background-color: ${({ theme }) => theme.palette.primaryBrand};
      color: ${({ theme }) => theme.palette.white};
    }

    &:hover {
      background: 0px ${({ theme }) => theme.palette.primaryBrand};
      color: ${({ theme }) => theme.palette.white};
    }
  }
  .CalendarDay__today:not(.CalendarDay__selected) {
    background: linear-gradient(
        to bottom right,
        transparent 90%,
        ${({ theme }) => theme.palette.primaryBrand} 0
      ),
      ${({ theme }) => theme.palette.white};
    :hover {
      background: 0px ${({ theme }) => theme.palette.primaryBrand};
    }
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background-color: ${({ theme }) => theme.palette.primaryBrand} !important;
    color: white;
    cursor: pointer;
    border-radius: 2px;
  }

  .DayPicker_weekHeader_li {
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.brownishGrey};
    :nth-last-child(-n + 2) {
      color: ${({ theme }) => theme.palette.clearBlue};
    }
  }

  .CalendarMonth_caption > strong {
    color: ${({ theme }) => theme.palette.primaryBrand};
    font-size: 14px;
  }
  .DayPickerNavigation_button__default {
    /* border: none !important; */
  }

  .CalendarMonthGrid,
  .CalendarMonthGrid_1,
  .CalendarMonthGrid__horizontal,
  .CalendarMonthGrid__horizontal_2 {
    width: 100%;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
      margin-top: 10px;
    }
  }

  .DayPicker,
  .DayPicker_1,
  .DayPicker__horizontal,
  .DayPicker__horizontal_2 {
    width: 100% !important;
    box-shadow: none;
    border-radius: 0px;
  }

  .CalendarMonth_table {
    margin-top: 10px;
  }

  .DayPicker_weekHeader__verticalScrollable {
    padding: 0px !important;
  }

  .CalendarDay__blocked_out_of_range,
  .CalendarDay__blocked_out_of_range:active,
  .CalendarDay__blocked_out_of_range:hover {
    pointer-events: none;
    background: ${({ theme }) => theme.palette.white};
    opacity: 0.5;
    color: ${({ theme }) => theme.palette.iron};
    cursor: not-allowed;
  }
`;

const NavButtonMixin = css`
  position: absolute;
  top: 20px;
`;

// TODO add "link" type button to setur-button component, then replace antd Button with ui-kit'
// import Button from '@components/Button';
export const NavPrevButton = styled(Button)`
  ${NavButtonMixin}
  left: 18px;
`;

export const NavNextButton = styled(Button)`
  ${NavButtonMixin}
  right: 18px;
`;

export const ResponsiveNavDownButton = styled(Button)`
  ${NavButtonMixin}
  width: 100%;
  height: 40px;
  z-index: 200;
  cursor: pointer !important;
  user-select: none !important;
  margin: 0px !important;
  border-width: 1px 1px 1px 0px !important;
  border-top-style: solid !important;
  border-right-style: solid !important;
  border-bottom-style: solid !important;
  border-top-color: rgb(228, 231, 231) !important;
  border-right-color: rgb(228, 231, 231) !important;
  border-bottom-color: rgb(228, 231, 231) !important;
  border-image: initial !important;
  color: rgb(117, 117, 117) !important;
  padding: 5px !important;
  background: rgb(255, 255, 255) !important;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 5px 2px !important;
  position: relative !important;
  display: inline-block !important;
  text-align: center !important;
  height: 100% !important;
  border-left-style: initial !important;
  border-left-color: initial !important;
  width: 100% !important;
`;

export const ResponsiveDatePickerWrapper = styled.div`
  /* max-width: 420px; */
`;
